import axios, { AxiosResponse } from "axios";
import { IUser } from "@/apps/person-registration/models/IUser";
import { authenticationApiUrls as apiUrl } from "@/apps/person-registration/services/apiClient/apiUrl";
import { IPersonLoginData } from "@/apps/merchant3/types/IPersonLoginData";

interface LoginData {
  personId: string;
  accessToken: string;
}

export default class AuthenticationService {
  public async signIn(data: IPersonLoginData): Promise<LoginData> {
    return await axios.post(apiUrl.SIGN_IN, data).then((response) => {
      const result = response.data.data;
      if (
        result.AuthenticationResult &&
        result.AuthenticationResult.AccessToken
      ) {
        localStorage.setItem("user", JSON.stringify(response.data));
        alert("Login was successful");
      }
      return response.data.data;
    });
  }

  public signUp(user: IUser): Promise<AxiosResponse<unknown>> {
    return axios.post(apiUrl.SIGN_UP, {
      username: user.username,
      password: user.password,
      email: user.email,
      name: user.name,
      phone_number: user.phone_number,
      given_name: user.given_name,
      middle_name: user.middle_name,
      family_name: user.family_name,
    });
  }

  public confirmSignUp(
    username: string,
    signUpConfirmationCode: string
  ): Promise<AxiosResponse<unknown>> {
    return axios.post(apiUrl.CONFIRM_SIGN_UP, {
      username: username,
      confirmation_code: signUpConfirmationCode,
    });
  }

  public signOut(): void {
    const user = localStorage.getItem("user");
    localStorage.removeItem("user");
    if (user) {
      const accessToken = typeof user === "string" ? JSON.parse(user) : {};
      axios
        .post(apiUrl.SIGN_OUT, {
          access_token: accessToken.AuthenticationResult.AccessToken,
        })
        .then((response: AxiosResponse<unknown>) => {
          if (response.status == 200) {
            alert("User signed out!");
          } else {
            alert("User didn't sign-out!");
          }
        });
    }
  }

  public forgotPassword(username: string): Promise<AxiosResponse<unknown>> {
    return axios.post(apiUrl.FORGOT_PASSWORD, {
      username,
    });
  }

  public confirmForgotPassword(
    username: string,
    confirmationCode: string,
    password: string
  ): Promise<AxiosResponse<unknown>> {
    return axios.post(apiUrl.CONFIRM_FORGOT_PASSWORD, {
      username,
      confirmationCode,
      password,
    });
  }
}
